import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { URI } from "core/classes/uri.class";

class LoadMoreItemsAJAX extends Class {
  constructor(element) {
    super();
    this.element = $(element);
    this.$loadMoreButton = this.element.find("[data-load-more-button]");
    this.$loadMoreButtonWrapper = this.element.find(
      "[data-load-more-button-wrapper]"
    );
    this.itemsToLoad = +this.$loadMoreButton.attr("data-items-to-load");
    this.offset = +this.$loadMoreButton.attr("data-items-offset");
    this.url = this.$loadMoreButton.attr("data-ajax-url");
    this.loadingMoreText = this.$loadMoreButton.attr("data-loading-more-text");
    this.$loadMoreContext = this.element.find("[data-load-more-context]");
    this.addAriaLabels();
    this.setUpEvents();
  }

  addAriaLabels() {
    this.$loadMoreContext.attr("aria-live", "assertive");
  }

  setUpEvents() {
    var self = this;

    this.$loadMoreButton.on("click", function() {
      self.load();
    });
  }

  load() {
    var self = this;

    this.removeErrorText();
    this.addLoadingState();
    this.addAriaLoadingText();

    $.ajax({
      url: this.getUrl()
    })
      .fail(function() {
        self.addErrorText();
      })
      .done(function(html) {
        self.addItems(html);
      })
      .always(function() {
        self.removeLoadingState();
        self.removeAriaLoadingText();
        $(window).trigger("abacus:InitUI", self.$loadMoreContext);
        $(window).trigger("abacus:loadmore:complete", self.element);
      });
  }

  getUrl() {
    var seperator = this.url.indexOf("?") > -1 ? "&" : "?";
    var uri =
      this.url +
      seperator +
      "offset=" +
      this.offset +
      "&items=" +
      this.itemsToLoad;
    return uri;
  }

  addItems(html) {
    var self = this,
      $lastChildItem = this.$loadMoreContext.children().last(),
      $temp = $("<div />");

    this.updateOffset();

    this.$loadMoreContext.append(html);

    var $nextItem = $lastChildItem.next();

    $nextItem
      .attr("tabindex", "0")
      .focus()
      .on("blur", function() {
        $(this)
          .removeAttr("tabindex")
          .off("blur");
      });

    var $lastAjaxItem = this.$loadMoreContext.find(".lastAjaxItem");

    if ($lastAjaxItem.length) {
      this.hideLoadMoreButton();
    }
  }

  updateOffset() {
    this.offset += this.itemsToLoad;
  }

  hideLoadMoreButton() {
    this.$loadMoreButtonWrapper.addClass("hide");
  }

  addLoadingState() {
    this.element.addClass("loading");
    this.$loadMoreButton.addClass("disabled").prop("disabled");
  }

  removeLoadingState() {
    this.element.removeClass("loading");
    this.$loadMoreButton.removeClass("disabled").prop("disabled", false);
  }

  addAriaLoadingText() {
    if (this.loadingMoreText) {
      this.$loadMoreContext.append(
        '<li class="assistive" data-aria-loading="">' +
          this.loadingMoreText +
          "</li>"
      );
    }
  }

  removeAriaLoadingText() {
    this.$loadMoreContext.children("[data-aria-loading]").remove();
  }

  addErrorText() {
    this.$loadMoreContext.append(
      '<li data-error=""><p class="error">There was an error loading the content.</p></li>'
    );
  }

  removeErrorText() {
    this.$loadMoreContext.children("[data-error]").remove();
  }
}

export { LoadMoreItemsAJAX };



// WEBPACK FOOTER //
// ./Javascript/core/classes/loadmoreitems/ajax.loadmoreitems.class.js